import Link from "next/link";

import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

export const ServiceReferralCardLink = styled(Link)(
  ({ theme }) => css`
    display: block;
    text-decoration: none !important;
    color: inherit;
    margin-block: 32px;

    ${theme.breakpoints.up("desktop")} {
      margin-block: 40px;
    }

    &:hover .service-referral-card__container {
      border-color: ${getColor(c => c.tokens.casestudy.embedded.base, theme)};
    }

    &:hover .service-referral-card__cta {
      color: ${getColor(c => c.tokens.casestudy.embedded.base, theme)};
    }
  `,
);

export const ServiceReferralCardContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px 32px;
    border-radius: 20px;
    background-color: ${theme.palette.mode === "dark" ? "#222530" : "#fcfcfc"};
    border: 1px solid ${getColor(c => c.tokens.stroke["sub-300"], theme)};
    box-shadow:
      0px 10px 22px -2.5px
        ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"},
      0px 2.29px 5.03px -1.67px
        ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"},
      0px 0.6px 1.32px -0.83px
        ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"};
    transition: border-color 0.2s ease;

    ${theme.breakpoints.up("tablet")} {
      padding: 32px 48px;
    }
  `,
);

export const ServiceReferralCardTitle = styled("p")(
  ({ theme }) => css`
    margin: 0;
    ${cssPropertiesToString(theme.typography.paragraph_xxlarge_semibold)};
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
  `,
);

export const ServiceReferralCardDescription = styled("p")(
  ({ theme }) => css`
    margin: 0;
    ${cssPropertiesToString(theme.typography.paragraph_large_regular)};
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
  `,
);

export const ServiceReferralCardCta = styled("span")(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-block-start: 8px;
    ${cssPropertiesToString(theme.typography.paragraph_medium_semibold)};
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
    transition: color 0.2s ease;
  `,
);
